import Component from './Component';

export default class BlogLegend extends Component {
  load() {
    // console.log('BlogLegend');

    const legendDropBtn = document.querySelectorAll('.legend__dropbtn');

    legendDropBtn.forEach(x => {
      x.addEventListener('click', (e) => {
        console.log('BlogLegend clicked');
        const el = e.target;
        console.log('el', el);
        const legendBlock = el.closest('.legend__block');
        const dropDown = legendBlock.querySelector('.legend__list');
        // const dropBtn = el.closest('.legend__dropbtn');
        // const dropDown = dropBtn?.nextElementSibling;
        // const dropDown = (el.classList.contains('legend__dropbtn')) ? el.nextElementSibling : el.closest('.legend__dropbtn').nextElementSibling;
        console.log('dropDown', dropDown);
        dropDown.classList.toggle('legend__list--open');
      });
    });

    super.load();

  }
}
